module.exports = "/shared/img/game-holder-bar.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/game-holder-bar.png
// module id = 438
// module chunks = 13